import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import { Collapse } from 'reactstrap';
import Awards from './EditAwards';
import Projects from './EditProjects';
import Courses from './EditCourses';
import Events from './EditEvents';
import VolunteerServices from './EditVolunteerServices';
import Publications from './EditPublications';
import Conferences from './EditConferences';
import Patents from './EditPatents';
import classnames from 'classnames';
import _ from 'lodash'
import TabSwitch from '../../../../common/TabSwitch'
import Actions from '../../../../appFlux/action'
import { accomplishmentTypes } from '../../../../appConstants'
import {
    BrowserRouter as Router, Switch, Route, useHistory
  } from "react-router-dom";
import { SelectDD , ExternalDD } from '../../../../common/dropdowns';

// const EditMyAccompModal2 = ({ modal, toggle }) => {
//     var history = useHistory();
//     const onNavigate = (o) => {
//       history.push(o)
//     }

//     const onDDClick = (o) => {
//       console.log("DD CLICK", o)
//       history.push(o.value)
//     }
//     const [selected, setSelected] = useState(accompData[0]);
//     const [collapse, setCollapse] = useState(false);
//     const togglecollapse = () => setCollapse(!collapse);

//     const [view, setView] = useState(0);
    
//     const renderView = (view) => {
//         switch(view) {
//             0: 
//                 return <div><Awards/></div>    
//             1: 
//                 return <div><Projects/></div>  
//             2: 
//                 return <div><Courses/></div> 
//             3: 
//                 return <div><Events/></div> 
//             4: 
//                 return <div><VolunteerServices/></div> 
//             5: 
//                 return <div><Publications/></div> 
//             6: 
//                 return <div><Conferences/></div> 
//             7: 
//                 return <div><Patents/></div>      
//         }
//     }

//     return (
//     <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">        
//         <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
//             <div className="modal-header">Edit Accomplishments</div>
//             <div className="v-align f-right" style={{marginLeft:'auto'}}>
//                 <i className="fa fa-cog modal-close mg-r-15" ></i> 
//                 <i className="far fa-question-circle modal-close mg-r-15" ></i>
//                 <i className="fas fa-times modal-close" onClick={toggle}></i>
//             </div>
//         </div>   
//         <hr className="mg-r-0"></hr>
//         <div className="modal-block">
//             <div className="modal-subheader">Add an Accomplishment</div>            
//             <div className="row">
//                 <div className="col-md-6">
//                 <SelectDD data={accompData} onChange={(o) => setSelected(o)} selected={selected} isClearable={false} />
//                 </div>
//                 <div className="col-md-6">
//                 <button className="btn btn-primary">
//                     <i className="fas fa-plus mg-r-5"></i>Add Accomplishment
//                     <span className="button-info">3</span>
//                 </button>
//                 </div>
//             </div>
//         </div>
//         <hr className="mg-0"></hr>
//             <div className="row">
//                 <div className="wd-pct-23 b-r-border pd-l-25 pd-r-5">
//                     <ul className="nav nav-left-tabs md-tabs tabs-left">
//                         <div className="col-md-12">
//                             <div className="row">
//                                 {links.map((l, i) => (
//                                     <Link
//                                         key={i}
//                                         idx={i}
//                                         title={l}
//                                         isActive={i === view}
//                                         handleOnClick={setView}
//                                      />
//                                 ))}
//                             </div> 
//                         </div> 
//                     </ul>
//                 </div>
//                 <div className="wd-pct-77 pd-t-15 pd-r-25 pd-l-15 pd-b-15">
//                     {renderView(view)}
//                 </div>
//             </div>       
        
//         <hr className="mg-0 "></hr>
//         <div className="pd-20 box-shadow-top">
//             <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>             
//             <button className="btn btn-primary-lite f-right mg-r-15">Save</button>
//             <button className="btn btn-success-lite mg-r-15 f-right">Reset</button>            
//         </div>
                 
//     </Modal>
// )}

const typeMap = {
    0:'awards',
    1:'projects',
    2:'courses',
    3:'volunteer',
    4:'publications',
    5:'conferences',
    6:'patents',
}

class EditMyExpModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, accomplishments } = props
        var type
        var index = 0
        console.log(accomplishments, "accomplishments")
        var keys =  _.keys(accomplishments)
        for(var key in keys){
            if(accomplishments[keys[key]].length > 0){
                type = keys[key]
                break
            }
        }
        this.state = {
            accomplishments: _.cloneDeep(accomplishments),
            type,
            index,
            inputAccomplishment: undefined
        }
    }

    // componentWillRecieveProps(props){
    //     var { modal, toggle, qualifications } = props
    //     console.log("I AM TRIGGERED.....................")
    //     this.setState({
    //         qualifications: _.cloneDeep(qualifications),
    //         index: qualifications.length > 0 ? 0 : undefined,
    //         inputDegree: "",
    //     })
    // }

    setType = (type) => {
        this.setState({ type, index: 0 })
    }

    setIndex = (index) => {
        this.setState({ index })
    }

    setAccomplishments = (value, param) => {
        var { accomplishments, index , type } = this.state
        accomplishments[type][index][param] = value
        this.setState({accomplishments})
    }

    addAccomplishments = (selectedType) => {
        var { accomplishments, index, type } = this.state
        type = selectedType && selectedType.value ? selectedType.value : type
        var myAccomplishment = {
            title: "",
            association: "",
            date: undefined,
            city: '',
            country: '',
            description: '',
            extrafield: '',
            extrafield2: '',
            extrafield3: ''
        }
        accomplishments[type].push(myAccomplishment)
        index = accomplishments[type].length - 1
        this.setState({accomplishments, index, type})
    }

    reset = () => this.setState({accomplishments: _.cloneDeep(this.props.accomplishments)})
    save = () => {
        Actions.setAccomplishments(this.state.accomplishments)
        this.props.toggle()
    }

    render() {
        var { modal, toggle } = this.props
        var { accomplishments, inputAccomplishment, index, type } = this.state
        var accomplishmentsTabs = accomplishmentTypes.filter(o => accomplishments[o.value].length > 0)
        console.log(accomplishmentsTabs)
        return (
            <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">
                <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                    <div className="modal-header">Edit Accomplishments</div>
                    <div className="v-align f-right" style={{ marginLeft: 'auto' }}>
                        <i className="fa fa-cog modal-close mg-r-15" ></i>
                        <i className="far fa-question-circle modal-close mg-r-15" ></i>
                        <i className="fas fa-times modal-close" onClick={toggle}></i>
                    </div>
                </div>
                <hr className="mg-r-0"></hr>
                    <div className="modal-block">
                        <div className="modal-subheader">Add an Accomplishment</div>            
                        <div className="row">
                            <div className="col-md-6">
                            <SelectDD data={accomplishmentTypes} onChange={(o) => this.setState({inputAccomplishment: o})} selected={inputAccomplishment} isClearable={false} />
                            </div>
                            <div className="col-md-6">
                            <button className="btn btn-primary" onClick={(o) => this.addAccomplishments(inputAccomplishment)}>
                                <i className="fas fa-plus mg-r-5"></i>Add Accomplishment
                                <span className="button-info">3</span>
                            </button>
                            </div>
                        </div>
                    </div>
                <hr className="mg-0"></hr>
                <div className="row">
                    <div className="wd-pct-23 b-r-border pd-l-25 pd-t-15 pd-r-5">
                        <ul className="nav nav-left-tabs md-tabs tabs-left">
                            <div className="col-md-12">
                                <div className="row">
                                    {accomplishmentsTabs.map((accomplishments, i) => (
                                        <TabSwitch
                                            key={accomplishments.value}
                                            idx={accomplishments.value}
                                            title={accomplishments.label}
                                            isActive={accomplishments.value === type}
                                            handleOnClick={this.setType}
                                        />
                                    ))}
                                </div>
                            </div>
                        </ul>
                    </div>
                    <div className="wd-pct-77 pd-t-15 pd-r-25 pd-l-15 pd-b-15">
                        {{ 
                            'awards': <Awards setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['awards']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>,
                            'projects': <Projects setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['projects']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>,  
                            'courses': <Courses setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['courses']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>, 
                            'events': <Events setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['events']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>, 
                            'volunteer': <VolunteerServices setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['volunteer']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>, 
                            'publications': <Publications setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['publications']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>, 
                            'conferences': <Conferences setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['conferences']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>, 
                            'patents': <Patents setAccomplishments={this.setAccomplishments} index={index} accomplishments={accomplishments['patents']} setIndex={this.setIndex} addAccomplishments={this.addAccomplishments}/>,
                        }[type]
                        }
                    </div>
                </div>
                <hr className="mg-0 "></hr>
                <div className="pd-20 box-shadow-top">
                    <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>
                    <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                    <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>
                </div>
            </Modal>
        )
    }
}
export default EditMyExpModal;